var version = {
    "name":      "dativery",
    "buildDateCode": "20251218-191311",
    "buildDate": "Thu Dec 18 2025 19:13:11 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251218-191311",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;